import { Styles } from 'reactxp';

export const colors = {
  alert: '#A31F36',
  background: '#f6f6f3',
  black: '#000000',
  body: '#333333',
  green: '#28a745',
  grey: '#666666',
  header: '#828226',
  hoverBlue: '#44A2FF',
  lightGrey: '#DDDDDD',
  menuBlue: '#0059A3',
  menuRed: '#b10838',
  orange: '#F5A623',
  otherRed: '#ff4a58',
  primary: 'rgb(33, 84, 132)',
  red: '#A0062D',
  secondary: 'rgba(22, 155, 213, 1)',
  secondaryBackground: '#c9e3f3',
  white: '#FFFFFF',
  yellow: '#FFEA00',
};

export const h1 = (multiplier) => Styles.createTextStyle({
  fontSize: multiplier > 1 ? 20 * multiplier : 26 * multiplier,
  fontWeight: '500'
});

export const h2 = (multiplier) => Styles.createTextStyle({
  fontSize: 20 * multiplier,
});

export const h3 = (multiplier) => Styles.createTextStyle({
  fontSize: 16 * multiplier,
  fontWeight: 'bold',
  marginVertical: 8 * multiplier
});

export const subHeader = (multiplier) =>  Styles.createTextStyle({
  fontSize: 14 * multiplier,
  // fontWeight: 'bold',
});

export const body = (multiplier) => Styles.createTextStyle({
  fontSize:  multiplier > 1 ? 11 * multiplier : 14 * multiplier,
});

export const button = (multiplier) => Styles.createTextStyle({
  fontSize: 18 * multiplier,
  fontWeight: '500',
});



// WEBPACK FOOTER //
// ./src/utils/styles.ts